<template>
  <div style="background-color: #f8f8f9">
    <div
      style="font-weight: 700;
    font-size: 32px;
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: 20px;padding-top:70px;"
      id="uc_seek"
    >
      Request For Upskill Classroom Free Trial
    </div>
    <div style="max-width: 600px; margin: 0 auto; ">
      <uform>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput2
            placeholder="Full Name"
            v-model="model.data.data.name"
            suggest=""
          ></uinput2>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput2
            placeholder="Email"
            v-model="model.data.data.email"
            suggest=""
          ></uinput2>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput2
            placeholder="Phone"
            v-model="model.data.data.phone"
            suggest=""
          ></uinput2>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput2
                  placeholder="Education Institution"
                  v-model="model.data.data.company"
                  suggest=""
          ></uinput2>
        </ulabel>
        <ubtn style="margin-left: auto; margin-right: auto; margin-bottom: 50px;" @click.native.prevent="submit()">Request</ubtn>
      </uform>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
        data: {
          data: {}
        },
        type: "classroom",
        status: "request"
      }
    };
  },
  methods: {
    submit() {
      this.model.created = new Date().toString();
      this.model.data.data.name = this.model.data.data.name
      this.$upskill
        .vault(this.model)
        .then(() => {
          this.SuccessAlert("Request submitted!");
          this.contactUs = false;
        })
        .error(() => {
          this.ErrorAlert("Something went wrong.");
        });
    }
  }
};
</script>
<style></style>
